module.exports = __webpack_public_path__ + "static/img/ikonaGaleriaDisabled-ON.3951e804.png";